import type {
  EmailVerificationVerifyRequest,
  SmsVerificationVerifyRequest,
} from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';
import type { VerifyOTPParams } from '../verifyOTP';

export const verifyOTPForUserUpdate = async (
  { otpVerification, verificationToken, requestedScopes }: VerifyOTPParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const verifyRequest:
    | EmailVerificationVerifyRequest
    | SmsVerificationVerifyRequest = {
    verificationToken,
    verificationUUID: otpVerification.verificationUUID,
  };
  if (requestedScopes) verifyRequest.requestedScopes = requestedScopes;

  if (otpVerification.email) {
    return apiClient.verifyEmailVerification({
      emailVerificationVerifyRequest: verifyRequest,
      environmentId: core.environmentId,
    });
  }

  return apiClient.verifySmsVerification({
    environmentId: core.environmentId,
    smsVerificationVerifyRequest: verifyRequest,
  });
};
